import type {
  SelectByConfirmationStatus,
  SelectBySituationScope,
} from "@/generated/fastapi";

type ThoughtQueryDefaults = {
  confirmationStatus: SelectByConfirmationStatus;
  situationScope: SelectBySituationScope;
  singleThoughtLookupSituationScope: SelectBySituationScope;
};

export const THOUGHT_QUERY_DEFAULTS = {
  confirmationStatus: "only_confirmed",
  situationScope: "assigned",
  singleThoughtLookupSituationScope: "all",
} as const satisfies ThoughtQueryDefaults;
